export const options = {
  layout: {
    improvedLayout: true,
    hierarchical: {
      // direction: "UD",
      sortMethod: 'directed'
    }
  },
  nodes: {
    shape: 'dot',
    size: 14,
    borderWidth: 4,
    borderWidthSelected: 4,
    font: { face: 'monospace', align: 'left' },
    color: {
      background: '#FAFAFA'
    },
    fixed: true
  },
  edges: {
    smooth: { enabled: true, type: 'straightCross' },
    arrows: {
      to: {
        enabled: false
      }
    }
  },
  physics: {
    hierarchicalRepulsion: {
      avoidOverlap: 5
    },
    solver: 'forceAtlas2Based',
    stabilization: true
  },
  groups: {
    vdc: {
      shape: 'dot',
      icon: {
        face: "'Ericsson Icons'",
        code: '\ue973',
        size: 50,
        color: 'black'
      }
    },
    epg: {
      shape: 'dot',
      icon: {
        face: "'Ericsson Icons'",
        code: '\ue98a',
        size: 50
      }
    },
    mme: {
      shape: 'dot',
      icon: {
        face: "'Ericsson Icons'",
        code: '\ue9d6',
        size: 50
      }
    },
    vm: {
      shape: 'dot',
      icon: {
        face: "'Ericsson Icons'",
        code: '\ue92b',
        size: 50
      }
    },
    shelf: {
      shape: 'dot',
      icon: {
        face: "'Ericsson Icons'",
        code: '\ue9d9',
        size: 50
      }
    }
  }
};
export const alarmsSeverity = [
  'Cleared',
  'Indeterminate',
  'Warning',
  'Minor',
  'Major',
  'Critical'
];
export const crmPriority = ['Critical', 'High', 'Medium', 'Low'];
export const incidentsPriority = ['Critical', 'High', 'Medium', 'Low'];
